function createMappings<T extends readonly string[]>(
    name: string,
    slots: T
): {
    slots: { [K in T[number]]: K }
    classes: { [K in T[number]]: string }
} {
    const slotsObject = Object.fromEntries(slots.map((key) => [key, key])) as { [K in T[number]]: K }
    const classesObject = Object.fromEntries(slots.map((slot) => [slot, `${name}-${slot}`])) as { [K in T[number]]: string }

    return {
        slots: slotsObject,
        classes: classesObject,
    }
}

const offersWidgetName = "OffersWidget"
const { slots: offersWidgetSlots, classes: offersWidgetClasses } = createMappings(offersWidgetName, [
    "root",
    "tabs",
    "tabPanel",
    "detailsButton",
] as const)
export { offersWidgetName, offersWidgetSlots, offersWidgetClasses }

const offerItemName = "OfferItem"
const { slots: offerItemSlots, classes: offerItemClasses } = createMappings(offerItemName, [
    "root",
    "erp",
    "erpAvailabilities",
    "erpPrices",
    "actions",
    "thumbnail",
] as const)
export { offerItemName, offerItemSlots, offerItemClasses }

const offersCarouselName = "OffersCarousel"
const { slots: offersCarouselSlots, classes: offersCarouselClasses } = createMappings(offersCarouselName, ["root"] as const)
export { offersCarouselName, offersCarouselSlots, offersCarouselClasses }

const simpleWidgetCardName = "SimpleWidgetCard"
const { slots: simpleWidgetCardSlots, classes: simpleWidgetCardClasses } = createMappings(simpleWidgetCardName, [
    "root",
    "cover",
    "card",
    "header",
    "content",
    "actions",
] as const)
export { simpleWidgetCardName, simpleWidgetCardSlots, simpleWidgetCardClasses }
